import {
  Instagram,
  LocalPhoneOutlined,
  MailOutline,
} from "@mui/icons-material";
import {
  Box,
  Button,
  Container,
  Grid,
  IconButton,
  ListItemButton,
  OutlinedInput,
  Stack,
  styled,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { CUSTOMER } from "../../config/constants";
import { pathContains } from "../../helpers";
import { IAuthState } from "../../stateManagement/reducers/authReducer";
import { setMainNavItem } from "../../stateManagement/reducers/menuReducer";
import { IOrdersState } from "../../stateManagement/reducers/ordersReducer";
import { IRootReducerT } from "../../stateManagement/reduxStore";
import AnimateButton from "../@extended/AnimateButton";

const Footer = () => {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const theme = useTheme();
  const idGreaterThanMd = useMediaQuery(theme.breakpoints.up("md"));
  const location = useLocation();
  const { user, authToken } = useSelector<IRootReducerT, IAuthState>(
    (state) => state.auth,
  );
  const { activeMembership } = useSelector<IRootReducerT, IOrdersState>(
    (state) => state.orders,
  );

  const title = process.env.REACT_APP_APP_NAME;
  const creatorName = process.env.REACT_APP_CREATOR_NAME;
  const creatorUrl = process.env.REACT_APP_CREATOR_URL;

  const slogan = "Legal Practitioners and Arbitrators";

  const officeAddress = "Suite 7, Law Hub, Ring Road, Ibadan";

  const line1 = "+234 818 856 6937";
  const line2 = "+234 812 999 1303";

  const [email, setEmail] = useState("");

  const socials = [
    {
      name: "Tik Tok",
      icon: (
        <img
          src="/images/tiktok.png"
          alt="Tik tok"
          style={{ display: "inline-block", width: "1rem", height: "1rem" }}
        />
      ),
      url: "https://www.tiktok.com/@rebirthwellness.ng",
    },
    {
      name: "Instagram",
      icon: (
        <Instagram sx={{ height: "1rem", width: "1rem", color: "#ffffffb3" }} />
      ),
      url: "https://www.instagram.com/rebirthwellness.ng",
    },
  ];

  const quickLinks1 = [
    {
      id: "welcome",
      title: "Home",
      type: "item",
      url: "/welcome",
      userAuth: false, //user-authentication is not a pre-requisite for visiting this  page
    },
    {
      id: "products",
      title: "Products",
      type: "item",
      url: "/products",
      userAuth: false,
    },
    {
      id: "services",
      title: "Services",
      type: "item",
      url: "/services/other-services",

      userAuth: false,
    },
    ...(user?.role?.name === CUSTOMER
      ? [
          {
            id: "orders",
            title: "orders",
            type: "item",
            url: "/orders",
            userAuth: false,
          },
        ]
      : []),
  ];

  const quickLinks2 = [
    {
      id: "about-us",
      title: "About Us",
      type: "item",
      url: "/welcome",
      section: "about-us",
      userAuth: false,
      children: [],
    },
    {
      id: "faq",
      title: "FAQs",
      type: "item",
      url: "/welcome",
      section: "faq",
      userAuth: false,
      children: [],
    },
    {
      id: "contact-us",
      title: "Contact Us",
      type: "item",
      url: "/welcome",
      section: "contact-us",
      userAuth: false,
      children: [],
    },
    // {
    //   id: "terms-and-conditions",
    //   title: "Terms & Conditions",
    //   type: "item",
    //   url: "/terms-and-conditions", //TODO: set route to terms & conditions page
    //   userAuth: false,
    // },
  ];

  const contacts = [
    {
      icon: <LocalPhoneOutlined />,
      name: "CALL US",
      value: "+234 707 919 0660",
      onClick: () => {
        window.open("tel:+2347079190660", "_self");
      },
    },
    {
      icon: <MailOutline />,
      name: "EMAIL US",
      value: "rebirthwellnesslimited@gmail.com",
      onClick: () => {
        window.open("mailto:rebirthwellnesslimited@gmail.com", "_self");
      },
    },
  ];

  const logoHeight = "2.5rem";
  const LogoImg = styled("img")(() => ({
    position: "relative",
    height: "100%",
    width: "100%",
    margin: "auto",
  }));

  return (
    <Stack
      alignItems="center"
      sx={{
        backgroundColor: `${theme.palette.background.default} !important`,
        width: "100%",
        marginTop: "0 !important",
        pt: "2rem",
        px: "1rem",
      }}
    >
      <Grid
        container
        sx={{
          width: "100%",
          maxWidth: "1800px !important",
        }}
        justifyContent="space-around"
      >
        <Grid item xs={12} md="auto" spacing={4}>
          <Stack
            alignItems={idGreaterThanMd ? "flex-start" : "center"}
            spacing="1rem"
            sx={{}}
          >
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-start"
              spacing=".5rem"
            >
              <Box
                sx={{
                  ml: idGreaterThanMd ? undefined : "1rem",
                  flexGrow: idGreaterThanMd ? undefined : 1,
                  height: idGreaterThanMd ? logoHeight : "3rem",
                  width: idGreaterThanMd ? logoHeight : "3rem",
                  cursor: "pointer",
                }}
              >
                <LogoImg
                  onClick={() => {
                    window.open("/", "_self");
                  }}
                  style={{ marginLeft: 0 }}
                  src="/images/logo.png"
                />
              </Box>
              <Stack alignItems="flex-start">
                <Stack
                  direction="row"
                  spacing=".5rem"
                  sx={{
                    "&>*": {
                      fontSize: "1.5rem !important",
                      lineHeight: "2rem !important",
                    },
                  }}
                >
                  <Typography sx={{ color: "white !important" }}>
                    Rebirth
                  </Typography>
                  <Typography sx={{ color: theme.palette.primary.main }}>
                    Wellness
                  </Typography>
                </Stack>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                  spacing=".5rem"
                  sx={{
                    "&>*": {
                      fontSize: ".6rem !important",
                      letterSpacing: ".28em !important",
                      fontFamily: "Inter !important",
                      color: theme.palette.secondary.main,
                    },
                  }}
                >
                  <Typography>RENEW</Typography>
                  <Typography>·</Typography>
                  <Typography>RESTORE</Typography>
                  <Typography>·</Typography>
                  <Typography>REBIRTH</Typography>
                </Stack>
              </Stack>
            </Stack>
            <Typography
              variant="body1"
              sx={{
                fontFamily: "Inter",
                textAlign: { xs: "center", md: "left" },
                fontWeight: "400",
                fontSize: ".875rem !important",
                lineHeight: "1.625 !important",
                cursor: "pointer",
                maxWidth: "20.125rem",
                color: "#ffffffb3 !important",
              }}
              onClick={() => {
                // Encode the address to make it URL-safe
                const encodedAddress = encodeURIComponent(officeAddress);

                // Create the Google Maps URL with the encoded address
                const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;

                // Open the Google Maps URL in a new tab
                window.open(googleMapsUrl, "_blank");
              }}
            >
              Nurse-led skincare and wellness — helping you feel renewed,
              confident, and supported. Beauty rooted in wellness.
            </Typography>
            <Stack direction="row" spacing=".75rem">
              {socials.map((social, i) => {
                return (
                  <AnimateButton>
                    <IconButton
                      key={i}
                      sx={{
                        border: "solid 1px #fff3",
                        p: ".75rem",
                      }}
                      onClick={() => {
                        window.open(social.url, "_blank");
                      }}
                    >
                      {social.icon}
                    </IconButton>
                  </AnimateButton>
                );
              })}
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={6} md="auto" sx={{ ml: { xs: "0", md: "8rem" } }}>
          <Stack
            alignItems={idGreaterThanMd ? "flex-start" : "flex-start"}
            spacing={3}
            sx={{}}
          >
            <Box
              sx={{
                opacity: "0%",
                display: { xs: "none", md: "flex" },
                height: logoHeight,
              }}
            >
              <IconButton
                onClick={() => {
                  window.open("/", "_self");
                }}
                sx={{
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                }}
              >
                <LogoImg src="/images/darkLogo.png" />
              </IconButton>
            </Box>
            <Stack alignItems={idGreaterThanMd ? "flex-start" : "center"}>
              <Typography
                sx={{
                  textAlign: { xs: "center", md: "left" },
                  color: "white !important",
                  fontSize: "1.25rem",
                  fontWeight: "600",
                }}
              >
                Quick Links
              </Typography>
              {quickLinks1.map((quickLink, i) => {
                return (
                  <ListItemButton
                    sx={{
                      pl: "0 !important",
                    }}
                    onClick={() => {
                      window.open(quickLink.url, "_self");
                    }}
                    key={i}
                  >
                    <Typography
                      sx={{
                        color: pathContains(location.pathname, quickLink.id)
                          ? `${theme.palette.primary.main} !important`
                          : "#ffffffb3 !important",
                        fontSize: ".875rem",
                        lineHeight: "1.25rem",
                        fontFamily: "Inter",
                      }}
                      variant="body1"
                    >
                      {quickLink.title}
                    </Typography>
                  </ListItemButton>
                );
              })}
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={6} md="auto">
          <Stack
            alignItems={idGreaterThanMd ? "flex-start" : "flex-end"}
            spacing={3}
            sx={{}}
          >
            <Box
              sx={{
                opacity: "0%",
                display: { xs: "none", md: "flex" },
                height: logoHeight,
              }}
            >
              <IconButton
                onClick={() => {
                  window.open("/", "_self");
                }}
                sx={{
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                }}
              >
                <LogoImg src="/images/darkLogo.png" />
              </IconButton>
            </Box>
            <Stack alignItems={idGreaterThanMd ? "flex-start" : "center"}>
              <Typography
                sx={{
                  textAlign: { xs: "center", md: "left" },
                  color: "white !important",
                  fontSize: "1.25rem",
                  fontWeight: "600",
                }}
              >
                Quick Links
              </Typography>
              {quickLinks2.map((quickLink, i) => {
                return (
                  <ListItemButton
                    onClick={() => {
                      dispatch(setMainNavItem(quickLink));
                      navigate(quickLink.url, { replace: false });
                    }}
                    sx={{
                      pl: "0 !important",
                    }}
                    key={i}
                  >
                    <Typography
                      sx={{
                        color: pathContains(location.pathname, quickLink.id)
                          ? `${theme.palette.primary.main} !important`
                          : "#ffffffb3 !important",
                        fontFamily: "Inter",
                        fontSize: ".875rem",
                        lineHeight: "1.25rem",
                      }}
                      variant="body1"
                    >
                      {quickLink.title}
                    </Typography>
                  </ListItemButton>
                );
              })}
            </Stack>
          </Stack>
        </Grid>
        <Grid item xs={12} md="auto">
          <Stack
            alignItems={idGreaterThanMd ? "flex-start" : "flex-start"}
            spacing={3}
            sx={{}}
          >
            <Box
              sx={{
                opacity: "0%",
                display: { xs: "none", md: "flex" },
                height: logoHeight,
              }}
            >
              <IconButton
                onClick={() => {
                  window.open("/", "_self");
                }}
                sx={{
                  "&:hover": {
                    backgroundColor: "transparent !important",
                  },
                }}
              >
                <LogoImg src="/images/darkLogo.png" />
              </IconButton>
            </Box>
            <Stack alignItems="flex-start" spacing={2}>
              <Typography
                sx={{
                  color: "white !important",
                  fontSize: "1.25rem",
                  fontWeight: "600",
                }}
              >
                Newsletter
              </Typography>
              <Typography
                sx={{
                  color: "#ffffffb3 !important",
                  fontSize: ".875rem",
                  lineHeight: "1.25rem",
                  fontFamily: "Inter",
                }}
                variant="body1"
              >
                Subscribe for the latest updates
              </Typography>
              <OutlinedInput
                id="email-reg"
                type="email"
                value={email}
                name="email"
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                placeholder="Enter your email"
                fullWidth
                error={Boolean(false)}
                sx={{
                  opacity: "100%",
                  borderRadius: "0",
                  border: "1px solid rgba(255, 255, 255, 0.80)",
                  backgroundColor: "rgba(0, 0, 0, 0.30)",
                  color: "#FFF !important",
                  fontStyle: "italic",
                  fontWeight: "500",
                  fontSize: ".75rem",
                  width: "100%",
                  maxWidth: "39.375rem !important",
                  minWidth: "0 !important",
                  "& .MuiInputBase-input": {
                    textAlign: "center",
                    color: "white !important",
                    maxWidth: "39.375rem !important",
                  },
                  "&::placeholder": {
                    color: "#FFF !important",
                    opacity: 1,
                  },
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
              />
              <Button
                variant="contained"
                fullWidth
                size="large"
                sx={{
                  mt: ".5rem",
                  px: "2rem",
                }}
              >
                SUBSCRIBE
              </Button>
            </Stack>
          </Stack>
        </Grid>
      </Grid>
      <Stack
        alignItems="flex-start"
        sx={{
          width: "100%",
          mt: { xs: "2rem", md: "1rem" },
          pl: { xs: "0", md: "3rem" },
        }}
      >
        <Typography
          sx={{
            textAlign: { xs: "center", md: "left" },
            color: "white !important",
            fontSize: "1.25rem",
            fontWeight: "600",
          }}
        >
          CONTACT
        </Typography>
        <Stack alignItems="flex-start" spacing="1rem" className="mt-[1rem]">
          {contacts.map((contact, i) => {
            return (
              <Stack
                key={i}
                direction="row"
                alignItems="center"
                justifyContent="flex-start"
                spacing=".5rem"
                sx={{
                  cursor: "pointer",
                  "&:hover .contactIconContainer > *, &:hover .footerContactValue":
                    {
                      color: theme.palette.primary.main,
                    },
                }}
                onClick={() => {
                  if (contact.onClick) {
                    contact.onClick();
                  }
                }}
              >
                <Box
                  className="contactIconContainer"
                  onClick={() => {
                    if (contact.onClick) {
                      contact.onClick();
                    }
                  }}
                  sx={{
                    borderRadius: "100%",
                    width: "fit-content",
                    height: "fit-content",
                    "&>*": {
                      color: "#ffffffb3",
                      height: "1.5rem",
                      width: "1.5rem",
                    },
                  }}
                >
                  {contact.icon}
                </Box>
                <Stack alignItems="flex-start">
                  <Typography
                    className="footerContactValue"
                    sx={{
                      color: "#ffffffb3",
                      fontFamily: "Inter",
                      fontSize: ".875rem",
                      lineHeight: "1.25rem",
                    }}
                  >
                    {contact.value}
                  </Typography>
                </Stack>
              </Stack>
            );
          })}
        </Stack>
      </Stack>
      <Container
        sx={{
          position: "relative",
          left: "-1rem",
          marginTop: "2rem",
          width: "calc(100% + 2rem) !important",
          maxWidth: "1600px !important",
          height: "1px",
          opacity: "0.5",
          backgroundColor: "#7b8d7780 !important",
        }}
      ></Container>
      <Stack
        direction={idGreaterThanMd ? "row" : undefined}
        alignItems={idGreaterThanMd ? "center" : "flex-start"}
        justifyContent={idGreaterThanMd ? "space-between" : undefined}
        sx={{
          py: "1rem",
          width: "100%",
          "& > *": {
            color: "#ffffff73",
            fontSize: ".75rem",
            lineHeight: "1rem",
            fontFamily: "Inter",
          },
          "& .creatorName": {
            color: `${theme.palette.secondary.main} !important`,
          },
        }}
      >
        <Typography>
          {"Created by "}
          <span
            className="creatorName"
            onClick={() => window.open(creatorUrl, "_blank")}
            style={{
              display: "inline-block",
              cursor: "pointer",
              borderBottom: "Solid .0625ren inherit",
            }}
          >
            {creatorName}
          </span>{" "}
          &copy; {new Date().getFullYear()}. All rights reserved.
        </Typography>
        <Typography>
          Nurse-Led · Real Results · Beauty Rooted in Wellness
        </Typography>
      </Stack>
    </Stack>
  );
};

export default Footer;
